export const CHATBOT_QUESTIONNAIRE_RECORD_ENDPOINT = {
    getVoiceAIRecordList: {
      url: '/v1/admin/questionnaire-log',
      method: 'GET',
    },
  };
  